import { render, staticRenderFns } from "./promocionesArticulo.vue?vue&type=template&id=25394776&scoped=true"
import script from "./promocionesArticulo.vue?vue&type=script&lang=js"
export * from "./promocionesArticulo.vue?vue&type=script&lang=js"
import style0 from "./promocionesArticulo.vue?vue&type=style&index=0&id=25394776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25394776",
  null
  
)

export default component.exports